module.exports = __webpack_public_path__ + "static/img/top.6ab93f9a.png";